import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spark_docs_banner = _resolveComponent("spark-docs-banner")!
  const _component_spark_docs_banner_second = _resolveComponent("spark-docs-banner-second")!
  const _component_spark_docs_banner_third = _resolveComponent("spark-docs-banner-third")!

  return (_openBlock(), _createBlock("div", {
    class: "side-bar-slider",
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stopAutoSlide && _ctx.stopAutoSlide(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startAutoSlide && _ctx.startAutoSlide(...args)))
  }, [
    _createVNode("div", {
      class: "side-bar-slider__container",
      style: _ctx.containerStyle
    }, [
      _createVNode(_component_spark_docs_banner, {
        class: "side-bar-slider__banner",
        onClick: _ctx.onBannerClicked
      }, null, 8, ["onClick"]),
      _createVNode(_component_spark_docs_banner_second, {
        class: "side-bar-slider__banner",
        onClick: _ctx.onBannerClicked
      }, null, 8, ["onClick"]),
      _createVNode(_component_spark_docs_banner_third, {
        class: "side-bar-slider__banner",
        onClick: _ctx.onBannerClicked
      }, null, 8, ["onClick"])
    ], 4)
  ], 32))
}